import * as React from "react"
import { Box, Skeleton } from "@mui/material"
import { PieAmchartSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { useLostBuyBoxOverviewShareChartsData } from "../@hooks"

const HEIGHT = 250


export default function BuyBoxShare() {

	const { isLoadingShareCharts, shareChartsData } = useLostBuyBoxOverviewShareChartsData()

	if (isLoadingShareCharts) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!shareChartsData?.buyBoxData?.length) return <></>
	
	return <Box>
		<PieAmchartSeeker
			rootID="BuyBoxShare"
			data={shareChartsData?.buyBoxData}
			title={<TitleWithPopover title="Winning vs Losing Buybox" />}
			series={[{
				yField: 'buyBox',
				xField: "num",
				innerRadius: 60,
			}]}
			sx={{ height: HEIGHT }}
			chartProps={{
				enabledPDF: false,
				chart: {
					horizontalLayout: true,
				},
				legend: {
					centerY: 50,
					y: 50,
					verticalLayout: true,
					labels: {
						maxWidth: 140,
						width: 140,
						oversizedBehavior: "wrap"
					},
					valueLabels: {
						textAlign: "right"
					}
				}
			}}
		/>
	</Box>
}